import { render, staticRenderFns } from "./LoadingMessage.vue?vue&type=template&id=51dcf540&scoped=true&"
import script from "./LoadingMessage.vue?vue&type=script&lang=js&"
export * from "./LoadingMessage.vue?vue&type=script&lang=js&"
import style0 from "./LoadingMessage.vue?vue&type=style&index=0&id=51dcf540&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dcf540",
  null
  
)

export default component.exports